import { isQuestionnaireItemEnabled } from '@liza/fhir-utils';
import type { Questionnaire, QuestionnaireItem, QuestionnaireResponse } from '@medplum/fhirtypes';

const hasAnswer = (response: QuestionnaireResponse | undefined, linkId: string): boolean => {
  const answers = response?.item?.find((i) => i.linkId === linkId)?.answer ?? [];
  return answers.some(
    (a) =>
      (a.valueString !== undefined && a.valueString !== '') ||
      a.valueBoolean !== undefined ||
      a.valueDate !== undefined ||
      a.valueDateTime !== undefined ||
      a.valueInteger !== undefined ||
      a.valueDecimal !== undefined ||
      a.valueQuantity?.value !== undefined ||
      a.valueCoding !== undefined,
  );
};

/**
 * linkIds of `required` questionnaire items that have no answer in `response`. Walks nested
 * groups and skips items whose `enableWhen` conditions are not met. Used to block submit and flag
 * unanswered required questions in the form.
 */
export const getUnansweredRequiredLinkIds = (
  questionnaire: Questionnaire,
  response: QuestionnaireResponse | undefined,
): string[] => {
  const result: string[] = [];
  const walk = (items: QuestionnaireItem[] | undefined): void => {
    for (const item of items ?? []) {
      if (item.type === 'group') {
        if (!isQuestionnaireItemEnabled(item, response)) continue;
        walk(item.item);
        continue;
      }
      if (item.type === 'display') continue;
      if (!isQuestionnaireItemEnabled(item, response)) continue;
      if (item.required && !hasAnswer(response, item.linkId)) result.push(item.linkId);
    }
  };
  walk(questionnaire.item);
  return result;
};
